__turbopack_context__.v({
  "Container": "GenericFilterToggle-module-scss-module__v5PcUW__Container",
  "HelperText": "GenericFilterToggle-module-scss-module__v5PcUW__HelperText",
  "Label": "GenericFilterToggle-module-scss-module__v5PcUW__Label",
  "Switch": "GenericFilterToggle-module-scss-module__v5PcUW__Switch",
  "SwitchWrap": "GenericFilterToggle-module-scss-module__v5PcUW__SwitchWrap",
  "TextContent": "GenericFilterToggle-module-scss-module__v5PcUW__TextContent",
  "Thumb": "GenericFilterToggle-module-scss-module__v5PcUW__Thumb",
  "checkIcon": "GenericFilterToggle-module-scss-module__v5PcUW__checkIcon",
  "closeIcon": "GenericFilterToggle-module-scss-module__v5PcUW__closeIcon",
  "disabled": "GenericFilterToggle-module-scss-module__v5PcUW__disabled",
  "dot": "GenericFilterToggle-module-scss-module__v5PcUW__dot",
  "root": "GenericFilterToggle-module-scss-module__v5PcUW__root",
  "secondary": "GenericFilterToggle-module-scss-module__v5PcUW__secondary",
  "switch": "GenericFilterToggle-module-scss-module__v5PcUW__switch",
  "thumb": "GenericFilterToggle-module-scss-module__v5PcUW__thumb",
});
